import React, { Component } from 'react';
import Layout from '../Layout';
import TaggerSubheader from './TaggerSubheader';
import FileUpload from './fileUpload';
import TaggedMweResults from './TaggedMweResults';
import { parseData } from './parseMwe';

class SearchMwe extends Component {

  constructor(props) {
    super(props);
    this.state = { results: [] };
    this.saveResults = this.saveResults.bind(this);
  }

  saveResults(id, name, response) {
    const rawData = response.result;
    const data = parseData(rawData);
    const res = {
      id,
      name,
      rawData,
      data,
      mweList: response.mwes || [],
    };
    this.setState({ results: [...this.state.results, res] })
  }

  render() {
    return (
      <Layout className="home">
        <TaggerSubheader />
        <div className="ml-4 mr-4">
          <h3 className="m-2">Pastoviųjų žodžių junginių nustatymas</h3>
          <FileUpload saveResults={this.saveResults} />
          <TaggedMweResults results={this.state.results} />
        </div>
      </Layout>
    );
  }
}

export default SearchMwe;
